import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../locales/LanguageProvider";  
import logo from '../../assets/img/logo/logo.svg';
import payment from '../../assets/img/payment.png';

const Footer = () => {
  const { Localizer, cult } = useLanguage();
  const t = (key) => Localizer(key, 'footer');

  // Arapça için özel telefon numarası
  const exportPhone = cult === 'ar' ? '+90 532 013 41 60' : '+90 541 485 01 68';
  const exportPhoneLink = cult === 'ar' ? 'tel:05320134160' : 'tel:05414850168';

  return (
    <footer className="footer-wrapper common-bg">
      <div className="footer-widget-area">
        <div className="container">
          <div className="footer-widget-inner section-space">
            <div className="row mbn-30">

              {/* Logo + İletişim */}
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="footer-widget-item mb-30">
                  <div className="footer-widget-logo">
                    <Link to="/">
                      <img src={logo} alt="Huzur Aksesuar Logo" style={{ width: "200px" }} />
                    </Link>
                  </div>
                  <ul className="footer-widget-body">
                    <li className="address"><em>{t("Adres")}:</em> Bağlar Mah. Koçman Cad. No.23/B1 Bağcılar İstanbul Türkiye</li>
                    <li className="phone"><em>{t("Tel")}:</em> <a href="tel:021248501679">+90 212 485 01 67</a></li>
                    <li className="phone"><em>Export:</em> <a href={exportPhoneLink}>{exportPhone}</a></li>
                    <li className="email"><em>e-mail:</em> <a href="mailto:info@huzurkiler.com.tr">info@huzurkiler.com.tr</a></li>
                  </ul>
                </div>
              </div>

              {/* Sayfalar */}
              <div className="col-lg-2 col-md-6 col-sm-6">
                <div className="footer-widget-item mb-30">
                  <div className="footer-widget-title"><h5>Huzur</h5></div>
                  <ul className="footer-widget-body">
                    <li><Link to="/about">{t("Hakkımızda")}</Link></li>
                    <li><Link to="/contact">{t("İletişim")}</Link></li>
                    <li><Link to="/info#kvkk">{t("KVKK")}</Link></li>
                    <li><Link to="/info#ink">{t("İnsan Kaynakları")}</Link></li>
                  </ul>
                </div>
              </div>

              {/* Ürünler */}
              <div className="col-lg-2 col-md-6 col-sm-6">
                <div className="footer-widget-item mb-30">
                  <div className="footer-widget-title"><h5>{t("Ürünler")}</h5></div>
                  <ul className="footer-widget-body">
                    <li><Link to="/products?mainct=0">{t("Mutfak")}</Link></li>
                    <li><Link to="/products?mainct=1">{t("Yatak Odası")}</Link></li>
                    <li><Link to="/products?mainct=2">{t("Banyo")}</Link></li>
                    <li><Link to="/info#cat">{t("Katalog")}</Link></li>
                  </ul>
                </div>
              </div>

              {/* Sosyal Medya + Bilgilendirme */}
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="footer-widget-item mb-30">
                  <div className="footer-widget-title"><h5>{t("Haberler ve Kampanyalar")}</h5></div>
                  <div className="footer-widget-body">
                    <p>{t("Instagram sayfamızı takip ederek, kampanyalarımızdan, yeni ürünlerimizden ve diğer haberler hakkında bilgi sahibi olabilirsiniz.")}</p>
                    <div className="footer-social-link">
                      <a href="https://www.linkedin.com/company/huzuraksesuar/" target="_blank" rel="noreferrer" className="linkedin" title="Linkedin"><i className="fa fa-linkedin"></i></a>
                      <a href="https://www.facebook.com/huzurturkey/" target="_blank" rel="noreferrer" className="facebook" title="Facebook"><i className="fa fa-facebook"></i></a>
                      <a href="https://www.instagram.com/huzuraksesuar/" target="_blank" rel="noreferrer" className="instagram" title="Instagram"><i className="fa fa-instagram"></i></a>
                      <a href="https://www.youtube.com/@@huzuraksesuar" target="_blank" rel="noreferrer" className="youtube" title="Youtube"><i className="fa fa-youtube"></i></a>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      {/* Footer bottom */}
      <div className="footer-bottom-area">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 order-2 order-md-1">
              <div className="copyright-text">
                <p>Made by &copy; {new Date().getFullYear()} <a href="https://pixedi.com/"><b>Pixedi Dijital Ajans</b></a></p>
              </div>
            </div>
            <div className="col-md-6 order-1 order-md-2">
              <div className="payment-method">
                <img src={payment} alt="Ödeme Yöntemleri" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
